import { render } from "./RatingBanner.vue?vue&type=template&id=f1f40b7e"
import script from "./RatingBanner.vue?vue&type=script&lang=js"
export * from "./RatingBanner.vue?vue&type=script&lang=js"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__